import { render, staticRenderFns } from "./ProductHome.vue?vue&type=template&id=b1dfdea2&scoped=true"
import script from "./ProductHome.vue?vue&type=script&lang=js"
export * from "./ProductHome.vue?vue&type=script&lang=js"
import style0 from "./ProductHome.vue?vue&type=style&index=0&id=b1dfdea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dfdea2",
  null
  
)

export default component.exports